<template>
    <base-input class="mb-3"
        :label="label"
        placeholder="YYYY/MM/DD"
        :label-classes="labelClasses"
        :value="value"
        :name="name"
        :rules="rules"
        :error="error"
        @input="process"
        @blur="normalize"
    >
    </base-input>
</template>

<script>
    export default {

        props: {

            label: {
                type: String,
            },

            labelClasses: {
                type: String,
                default: "form-control-label"
            },

            value: {
                type: [String, Number],
            },

            name: {
                type: String,
                default: ''
            },

            rules: {
                type: [String, Array, Object],
                default: ''
            },

            error: {
                type: String,
            },
        },

        methods: {

            process(value) {
                const filtered = value.replace(/[^0-9]/g, '')
                    .replace(/^(\d{4})(\d{2})?/g, '$1/$2')
                    .replace(/^(\d{4})\/(\d{2})(\d{2})?/g, '$1/$2/$3')
                    .substr(0, 10)

                let date = filtered.split('/')
                if (parseInt(date[1]) > 12) {
                    date[1] = 12
                }
                if (parseInt(date[2]) > 31) {
                    date[2] = 31
                }
                this.$emit('input', date.join('/'))
            },

            normalize() {
                let date = this.value.split('/')
                if (date.length == 0) {
                    return
                }
                // Year.
                while (date[0].length < 4) {
                    if (date[0].length < 3) {
                        date[0] = '0' + date[0]
                    } else {
                        date[0] = '2' + date[0]
                    }
                }
                // Month.
                if (date.length == 1) {
                    date.push('01')
                }
                if (date[1] == '') {
                    date[1] = '01'
                }
                while (date[1].length < 2) {
                    date[1] = '0' + date[1]
                }
                // Day.
                if (date.length == 2) {
                    date.push('01')
                }
                if (date[2] == '') {
                    date[2] = '01'
                }
                while (date[2].length < 2) {
                    date[2] = '0' + date[2]
                }

                this.$emit('input', date.join('/'))
            }
        }
    }
</script>
